<template>
    <div id="content6">
        <div v-for="type in typesWithNews" :key="type.id">
            <div class="content6Title"><p>{{ type.name }}</p></div>
            <router-link class="content6TitleNews" v-for="news in newsByType[type.id]" :key="news.id" :to="{ name: 'news', params: { id: news.id }}" target="_blank">
                <img :src='img_url + "/web_img/point.jpg"' alt="">
                <p>{{news.title}}</p>
            </router-link>
        </div>
    </div>
</template>

<script>
import { request } from '@/api/http';
import { NEWS_TYPES } from '@/constants/newsTypes';

export default {
    data () {
        return {
            newsTypes: NEWS_TYPES,
            newsTypeList: [],
            // 按类型 id 分组后的新闻，模板直接遍历
            newsByType: {},
            img_url: 'images',
        }
    },
    computed: {
        // 只保留有新闻的类型，空类型的整块不显示
        typesWithNews(){
            return this.newsTypes.filter(t => this.newsByType[t.id] && this.newsByType[t.id].length);
        },
    },
    mounted(){
        this.gettypenews();
    },

    methods: {
        gettypenews(){
            request('/CalawaEnServlet/NewsServlet', { type: 'getAllTypeNews' })
            .then(res=> {
                this.newsTypeList = res.data;
                this.groupByType();
            })
            .catch(error=> {
                console.log(error);
            });
        },
        groupByType(){
            const grouped = {};
            this.newsTypes.forEach(t => { grouped[t.id] = []; });
            this.newsTypeList.forEach(item => {
                if (!item) return;
                if (!grouped[item.type]) grouped[item.type] = [];
                grouped[item.type].push(item);
            });
            this.newsByType = grouped;
        },
    }
}
</script>

<style lang="scss" scoped>
@mixin manyLine($v){
    overflow: hidden;  
    text-overflow: ellipsis;  
    display: -webkit-box;  
    -webkit-line-clamp: $v;  
    -webkit-box-orient: vertical;
}
#content6{
    width:1000px;
    margin-top:10px;
    background-color: white;

    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    > div{
        width: 313px;
        height: 150px;
        
        padding: 10px;
        
        .content6Title{
            width: 313px;
            height: 43px;

            display: inline-block;

            background: url(../../assets/leftpart/content6/new_title_s-blue.jpg) no-repeat center;
            background-size: 313px 43px;       
            color:white;

            text-align: left;
            margin: 0;

            padding:0;
            p{
                padding: 11px 0 0 8px;
                font-size: 15px;
            }
        }
        img{
            margin: 3px 0 0 0px;
            float: left;
        }
        .content6TitleNews{
            text-align: left;
            // height: 300px;
            & { 
                text-decoration:none;
                color:black;
            }
            &:hover { text-decoration:none; cursor: pointer;}

            p{
                width: 280px;
                height: 19px;

                font-size: 13px;

                margin: 3px 0 0 10px;

                float: left;

                overflow:hidden; 
                white-space:nowrap;
                text-overflow:ellipsis;
            }
        }

    }
}
</style>
